import { deserialize, identifier, list, object, serializable } from "serializr";
import { IJsonObject } from "../../api";
import { Library } from "../library/Library";

interface IProps {
	id?: number;
	code?: string;
	name?: string;
	libraries?: Library[];
}

export class Bundle {
	public static fromJson(json: IJsonObject): Bundle {
		return deserialize(Bundle, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Bundle[] {
		return json.map((bundle: IJsonObject) => this.fromJson(bundle));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public code: string;

	@serializable
	public name: string;

	@serializable(list(object(Library)))
	public libraries: Library[];

	constructor({ id = 0, code = "", name = "", libraries = [] }: IProps = {}) {
		this.id = id;
		this.code = code;
		this.name = name;
		this.libraries = libraries;
	}
}
